module.exports = __webpack_public_path__ + "IS.png?e6aa918797ae30e913a1eeb0bfc71823";